import { makeStyles } from '@rbx/ui';
import {
  appMain,
  getMainWidthForCenterContentXL,
  getAppMainHeight,
  getXLCenterContentMediaQuery,
  getXLBreakpoint,
  leftNavWidth,
  collapsedLeftNavWidth,
} from '../constants/layoutConstants';

const useAppLayoutMainStyles = makeStyles<{
  showSecondaryNavigation: boolean;
  leftNavIsOpen: boolean;
  hasLeftNav: boolean;
  hasRightNav: boolean;
  mainMaxWidth: number;
}>()((theme, { leftNavIsOpen, showSecondaryNavigation, hasLeftNav, hasRightNav, mainMaxWidth }) => {
  const height = getAppMainHeight(showSecondaryNavigation);
  const mainWidthXL = getMainWidthForCenterContentXL(mainMaxWidth);
  return {
    container: {
      height,
      overflowX: 'hidden',
      overflowY: 'auto',
      minHeight: height,
      background: theme.palette.surface[0],
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      alignItems: 'center',
    },

    content: {
      [getXLCenterContentMediaQuery(mainMaxWidth)]: {
        // if has left nav, add padding to the left to center content.
        // note that nested children do not need centering,
        // as they are left aligned to the content by the parent, here
        paddingLeft: hasLeftNav ? `calc(calc(100vw - ${mainWidthXL}px) / 2)` : 0,
      },
      [theme.breakpoints.between('Large', getXLBreakpoint(mainMaxWidth))]: hasLeftNav
        ? {
            marginLeft: `${leftNavIsOpen ? leftNavWidth : collapsedLeftNavWidth}px`,
          }
        : {},
    },

    main: {
      minHeight: height,
      padding: theme.spacing(...appMain.spacing.default),
      [theme.breakpoints.down('XLarge')]: {
        padding: theme.spacing(...appMain.spacing.lg),
        justifyContent: 'center',
      },
      [theme.breakpoints.down('Large')]: {
        padding: theme.spacing(...appMain.spacing.md),
      },
    },

    appLayoutMainContentWrapper: {
      ...(hasRightNav
        ? {
            [theme.breakpoints.up('Large')]: !leftNavIsOpen
              ? {}
              : {
                  maxWidth: `min(75vw, ${mainMaxWidth}px)`,
                },
            [getXLCenterContentMediaQuery(mainMaxWidth)]: {
              maxWidth: undefined,
            },
          }
        : {}),
      minHeight: height,
      minWidth: 0,
      alignItems: 'stretch',
      fontSize: 16,
    },
  };
});

export default useAppLayoutMainStyles;
